import React, { useCallback, useMemo } from 'react'
import { IMemberBenefit, IVoteItem } from '@verzekeringapp-mono/shared/src/models/member_benefit'
import useMemberBenefits from '@verzekeringapp-mono/shared/src/hooks/use_member_benefits'
import { useAppSelector } from '@verzekeringapp-mono/shared/src/hooks/state'
import { getIsMemberBenefitLoading } from '@verzekeringapp-mono/shared/src/state/selectors/member_benefits'
import Modal from '~/components/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Button from '~/components/Button'

interface IProps {
  memberBenefit: IMemberBenefit
}

const MemberBenefitVote: React.FC<IProps> = ({ memberBenefit }) => {
  const { vote } = useMemberBenefits()
  const isLoading = useAppSelector(getIsMemberBenefitLoading)
  const [infoVoteItem, setInfoVoteItem] = React.useState<IVoteItem | null>(null)
  const [selectedVoteItem, setSelectedVoteItem] = React.useState<IVoteItem | null>(null)

  const voteButtonPressed = useCallback((voteItem: IVoteItem) => {
    vote(`${memberBenefit.id}`, voteItem.id)
  }, [memberBenefit, vote])

  const hasVoted = useMemo(() => memberBenefit.voteItems?.some(voteItem => voteItem.userVote), [memberBenefit.voteItems])

  if (memberBenefit.memberBenefitType !== 'Stemactie') {
    return null
  }

  return (
    <>
      <div className='flex flex-col gap-2 mt-4'>
        {memberBenefit.voteItems?.map(voteItem => (
          <div
            key={voteItem.id}
            className={`mb-2 flex w-full flex-row rounded-md ${voteItem.userVote || voteItem === selectedVoteItem ? 'bg-surface-inverse' : 'bg-surface-card'} ${hasVoted ? 'cursor-default' : 'cursor-pointer'}`}
            onClick={() => {
              if (hasVoted) return

              setSelectedVoteItem(voteItem)
            }}
          >
            <p className={`flex-1 p-4 text-left ${voteItem.userVote || voteItem === selectedVoteItem ? 'text-text-inverse' : 'text-text-primary'}`}>
              {voteItem.title}
            </p>

            <button
              type='button'
              className={`border-l px-6 py-2 ${voteItem.userVote || voteItem === selectedVoteItem ? 'border-border-inverse text-text-inverse' : 'border-border-default text-text-muted'}`}
              onClick={(e) => { e.stopPropagation(); setInfoVoteItem(voteItem) }}
            >
              <FontAwesomeIcon icon='info' />
            </button>
          </div>
        ))}

        <Button
          className={'w-full rounded-md bg-action-primary-background px-4 py-4 text-action-primary-foreground'}
          onClick={() => { if (selectedVoteItem) voteButtonPressed(selectedVoteItem) }}
          disabled={isLoading || hasVoted || !selectedVoteItem}
          isLoading={isLoading}
        >
          {hasVoted ? 'Stem uitgebracht' : 'Stemmen'}
        </Button>
      </div>

      {infoVoteItem && (
        <Modal onClose={() => { setInfoVoteItem(null) }}>
          <h1 className='text-2xl font-bold mb-4'>{infoVoteItem.title}</h1>

          <p dangerouslySetInnerHTML={{ __html: infoVoteItem.content }}/>
        </Modal>
      )}
    </>
  )
}

export default MemberBenefitVote
